export const CAT_PAGE_PATHNAME = '/cat.php';
